"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSMediatingScene = void 0;
const Game_1 = require("./Game");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const TSOptions_1 = require("./TSOptions");
class TSMediatingScene extends Phaser.Scene {
    constructor() {
        super("TSMediatingScene");
    }
    create() {
        this.audio_scene = Game_1.game_manager.add_or_get_audio_scene(this);
        this.audio_scene.play('bg_audio', true, true, 0.5);
        this.add.sprite(0, 0, 'controls').setOrigin(0);
        this._controller = Game_1.game_manager.getController();
        this._controller.register(KHInputScene_1.KHInputScene.SharedInput);
        // global_save.reset()
        console.log(TSOptions_1.global_save.level.get());
        if (TSOptions_1.global_save.level.get() == 0) {
            this.scene.start("TSMenuScene");
        }
        else if (TSOptions_1.global_save.level.get() == Game_1.game_manager.getGames().length) {
            this.scene.start("TSEndScene", { anim: false });
        }
        else {
            this.scene.start("TSGameScene", null);
        }
    }
}
exports.TSMediatingScene = TSMediatingScene;
